export default "__VITE_ASSET__DRBG7HXo__"